module.exports = "<div class=\"progress\"\n  ng-class=\"{grey: !overLoad, red: overLoad}\">\n  <div class=\"determinate orange\"\n    ng-style=\"{'width' : progress}\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/loading/myLoadingBar.html
// module id = 1212
// module chunks = 0